import { Permission } from "./enums";

/**
 * Check requested permission.
 * @param accountPermissions - permissions of checked account
 * @param checked - permission to be checked
 * @return <i>true</i> if checked permission is present in account permissions, <i>false</i> otherwise
 */
export const hasPermission = (accountPermissions: Permission[], checked: Permission): boolean => {
  return accountPermissions.includes(checked);
};

/**
 * Check if all permissions are present in account permissions.
 * @param accountPermissions - permissions of checked account
 * @param checked - permissions to be checked
 * @return <i>true</i> if all checked permissions are present in account permissions, <i>false</i> otherwise
 */
export const hasAllPermissions = (accountPermissions: Permission[], checked: Permission[]): boolean => {
  return checked.every((perm) => perm && accountPermissions.includes(perm));
};

/**
 * Check if any of given permissions is present in account permissions.
 * @param accountPermissions - permissions of checked account
 * @param checked - permissions to be checked
 * @return <i>true</i> if any of checked permissions is present in account permissions, <i>false</i> otherwise
 */
export const hasAnyPermission = (accountPermissions: Permission[], checked: Permission[]): boolean => {
  return checked.some((perm) => perm && accountPermissions.includes(perm));
};
